import { setCode } from './mixins/campaign';

if(document.querySelector('.order-form-2025')) {
    import(
        /* webpackChunkName: "order-form-2025" */
        /* webpackMode: "lazy" */
        './order'
    );
}

setCode();
